export const BOX_FOLDERS_ORDER_DEFAULT = {
  INBOX: 'modified.time desc', // modified.time will be converted into modifiedTime for api requests
  TRASH: 'deletedTime desc',
  FILES: 'displayName asc',
}
